import _ from 'lodash'
import store from '@/store'

/**
 * General helper methods
 */
export default {
  install: (Vue, options) => {
    Vue.prototype.$helpers = {
      showErrorAlert: (title, subtitle, isHtml, dismissAfter) => {
        store.dispatch('SHOW_ALERT', {
          title: title,
          subtitle: subtitle,
          isHtml: isHtml || false,
          level: 'error'
        })

        setTimeout(() => {
          store.dispatch('HIDE_ALERT')
        }, dismissAfter || 5000)
      },
      showSuccessAlert: (title, subtitle, isHtml, dismissAfter) => {
        store.dispatch('SHOW_ALERT', {
          title: title,
          subtitle: subtitle,
          isHtml: isHtml || false,
          level: 'success'
        })

        setTimeout(() => {
          store.dispatch('HIDE_ALERT')
        }, dismissAfter || 3000)
      },
      showInfoAlert: (title, subtitle, isHtml, dismissAfter) => {
        store.dispatch('SHOW_ALERT', {
          title: title,
          subtitle: subtitle,
          isHtml: isHtml || false,
          level: 'info'
        })

        setTimeout(() => {
          store.dispatch('HIDE_ALERT')
        }, dismissAfter || 5000)
      },
      showWarningAlert: (title, subtitle, isHtml, dismissAfter) => {
        store.dispatch('SHOW_ALERT', {
          title: title,
          subtitle: subtitle,
          isHtml: isHtml || false,
          level: 'warning'
        })

        setTimeout(() => {
          store.dispatch('HIDE_ALERT')
        }, dismissAfter || 5000)
      },
      hideAlert: () => {
        store.dispatch('HIDE_ALERT')
      },

      explode: function (str, delimiter) {
        let retval = []
        let splitted = str.split(delimiter)

        if (splitted && splitted.length > 0) {
          splitted.forEach((v) => {
            v = _.trim(v, ' ,')

            if (v) {
              retval.push(v)
            }
          })
        }

        return retval
      },

      // Combine keys and values of an object
      arrayCombine: (keys, values, skipEmpty) => {
        let out = {}
        let skip = !!skipEmpty

        // Loop the keys and add value from values if exists, else null
        Object.keys(keys).forEach(k => {
          if (values.hasOwnProperty(k)) {
            out[k] = values[k]
          } else {
            out[k] = null
          }

          // if we want to skip empty values, i.e. null and empty strings
          if (skip) {
            if (out[k] === null || out[k] === 'null' || out[k] === '') {
              delete out[k]
            }
          }
        })
        return out
      },

      // Set values if not isset or is null / false
      setObjectValues: (keys, object) => {
        Object.keys(keys).forEach(k => {
          if (
            !object.hasOwnProperty(k) ||
            object[k] === null ||
            object[k] === false
          ) {
            object[k] = keys[k]
          }
        })
      },

      softClone: (from, to) => {
        Object.keys(from).forEach(k => {
          to[k] = from[k]
        })
      },

      isTrue: (value) => {
        return value === true || value === 'true' || value === 1 || value === '1'
      },

      isFalse: (value) => {
        return value === null || value === 'null' || value === false || value === 'false' || value === 0 || value === '0'
      },

      getTwentyfourSevenError: (caughtError) => {
        if (!caughtError) {
          return false
        }

        const parsed = JSON.parse(JSON.stringify(caughtError))

        if (!_.has(parsed, 'response.data.errors.twentyfoursevensoaperror')) {
          return false
        }

        const errors = parsed.response.data.errors.twentyfoursevensoaperror

        if (!errors || errors.length < 1) {
          return false
        }

        return errors[0]
      },

      getCustomErrors: (caughtError) => {
        try {
          const parsed = caughtError
            ? JSON.parse(JSON.stringify(caughtError))
            : null

          const errors = _.has(parsed, 'response.data.errors')
            ? parsed.response.data.errors
            : null

          return errors
        } catch (e) {
          // Ignore
        }

        return []
      },

      // Put api errors into the Vee validate error holder
      sendApiErrorsToValidator: (caughtError, errorHolder, defaultField) => {
        let parsed = caughtError
          ? JSON.parse(JSON.stringify(caughtError))
          : null

        let errors = _.has(parsed, 'response.data.errors')
          ? parsed.response.data.errors
          : null

        // console.log(parsed)
        if (_.isEmpty(errors)) {
          errorHolder.add({
            field: defaultField || 'id',
            rule: '_unknown',
            msg: _.has(parsed, 'response.data.message')
              ? parsed.response.data.message
              : 'Ukjent feil'
            // scope: 'api'
          })
        } else {
          Object.keys(errors).forEach(field => {
            if (typeof errors[field] !== 'object') {
              errorHolder.add({
                field: field,
                rule: '_unknown',
                msg: errors[field] ? errors[field] : 'Ukjent feil'
                // scope: 'api'
              })
            } else {
              Object.keys(errors[field]).forEach(errType => {
                errorHolder.add({
                  field: field,
                  rule: isNaN(errType) ? errType : '_unknown',
                  msg: errors[field][errType]
                  // scope: 'api'
                })
              })
            }
          })
        }
      },

      // Check bruker password strongness
      passwordStrongnessRule: value => {
        return new Promise(resolve => {
          let reg = /\d+/

          if (!reg.test(value)) {
            resolve({
              valid: false,
              data: { message: 'Passord må inneholde et nummer' }
            })
          }

          reg = /[A-ZÅÄÖÆØÜ]+/
          if (!reg.test(value)) {
            resolve({
              valid: false,
              data: { message: 'Passord må inneholde en stor bokstav' }
            })
          }

          reg = /[a-zåäöæøü]+/
          if (!reg.test(value)) {
            resolve({
              valid: false,
              data: { message: 'Passord må inneholde en liten bokstav' }
            })
          }

          resolve({ valid: true })
        })
      },

      toggleSidebar: elementId => {
        let el = window.jQuery('#' + elementId)

        el.toggleClass('active')

        if (!el.hasClass('no-transition')) {
          setTimeout(function () {
            el.addClass('no-transition')
          }, 200)
        } else {
          el.removeClass('no-transition')
        }
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/plugins/helpers.js